import moment from "moment-timezone";
import { TIMEZONE } from "../config/constants";

// e.g. Jan 1, 2013
const FORMAT_DEFAULT = "MMM D, yyyy";

function startOfDay(date: number | string | Date) {
  return moment.tz(date, TIMEZONE).startOf("day").toISOString()
}

function endOfDay(date: number | string | Date) {
  return moment.tz(date, TIMEZONE).endOf("day").toISOString();
}

function getDefaultFormat(date): string {
  try {
    const result = moment(date).format(FORMAT_DEFAULT);
    if (typeof result !== "string") throw new Error();
    return result;
  } catch (ignore) {
    return "";
  }
}

function getTitleFormat(date): string {
  try {
    const result = moment(date).format("DD MMMM yyyy");
    if (typeof result !== "string") throw new Error();
    return result;
  } catch (ignore) {
    return "";
  }
}

function getSubmissionDateFormat(date, noTime = false): string {
  try {
    if (!date) return "";
    const result = noTime ? moment(date).format("DD MMMM YYYY") :
      moment(date).format("DD MMMM YYYY, HH:mm A");

    if (typeof result !== "string") throw new Error();
    return result;
  } catch (ignore) {
    return "";
  }
}

function getSubmissionStatus(deadline: any, submissionDate: any): { status: string; className: string } {
  if (!deadline || !submissionDate) {
    return { status: "Unknown", className: "neutral" };
  }

  const deadlineMoment = moment(deadline);
  const submissionMoment = moment(submissionDate);

  if (submissionMoment.isAfter(deadlineMoment)) {
    return { status: "Overdue", className: "negative" };
  } else {
    return { status: "On Time", className: "positive" };
  }
}

function isBeforeSubmissionDue(due) {
  if (!due) {
    return false;
  }

  const dueDate = new Date(due);
  const now = new Date();

  return dueDate > now;
}

function formatSubmissionDateRange(fromInput, toInput) {
  const from = moment(fromInput);
  const to = moment(toInput);

  return `${from.format(FORMAT_DEFAULT)} - ${to.format(FORMAT_DEFAULT)}`;
}

function parseSubmissionDateFromList(
  submissionDateId: string,
  submissionDateList: Array<{ value: string; fromMs: number; toMs: number; }>
) {
  let found = false;
  let startDate = "";
  let endDate = "";
  let index = -1;

  if (
    Array.isArray(submissionDateList) &&
    submissionDateList.length > 0 &&
    (index = submissionDateList.findIndex(i => i.value === submissionDateId)) > -1
  ) {
    found = true;
    startDate = ModuleDate.getSubmissionDateFormat(submissionDateList[index].fromMs, true);
    endDate = ModuleDate.getSubmissionDateFormat(submissionDateList[index].toMs, true);
  }

  return {
    found,
    startDate,
    endDate
  };
};

const ModuleDate = {
  startOfDay,
  endOfDay,
  getDefaultFormat,
  getTitleFormat,
  getSubmissionDateFormat,
  getSubmissionStatus,
  isBeforeSubmissionDue,
  formatSubmissionDateRange,
  parseSubmissionDateFromList
};

export default ModuleDate;
